import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { TAModel } from 'src/app/_Core/_Models/TA.model';
import { AdminService } from 'src/app/_Core/_Services/admin.service';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { NotificationService } from 'src/app/_Core/_Services/notification.service';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';

@Component({
  standalone: false,
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit {
  @Input() item;
  allSideNav: any = [];
  sideNav1: any = [];
  sideNav2: any = [];
  sideNavProd1: any = [];
  sideNavProd2: any = [];
  selectedIndex: any = 0;
  showBookingStatus: boolean = true;
  locationUrl;
  selectedMenu: any;
  routerSubscription: any;
  profile: boolean;
  adminData = new TAModel();
  initials: string = '';
  userType = localStorage.getItem('userType');
  expandVMS: boolean = false;
  expandPMS: boolean = false;
  subIndex: any;
  constructor(
    public router: Router,
    private location: Location,
    private appStateSrv: AppStateProvider,
    private adminSrv: AdminService,
    private notificationSrv: NotificationService
  ) {
    router.events.subscribe((val) => {
      this.locationUrl = location.path();
    });
  }
  profileClick() {
    this.profile = true;
    this.selectedIndex = '10';
    this.router.navigate(['/profile']);
  }
  ngOnInit() {
    const navState = localStorage.getItem('expandNav') == 'true';
    this.expandVMS = navState;
    this.expandPMS = navState;

    if (
      localStorage.getItem(AppConstant.localStorage.token) !== null &&
      localStorage.getItem(AppConstant.localStorage.token) !== 'token' &&
      localStorage.getItem(AppConstant.localStorage.token) !== ''
    ) {
      if (this.userType == 'Bridge+') {
        console.log('Bridge+');
        this.getAdminData();
      } else {
        console.log('Parkite+');

        this.getParkiteAdmin();
      }
    }

    this.appStateSrv.getSetNavState().subscribe((state) => {
      console.log(state);
      if (state !== undefined) {
        this.item = [state];
        console.log(this.item);
        if (this.item[0].hasOwnProperty('sub') && this.item[0].sub.length > 0) {
          this.selectNav(this.item, this.item[0].sub[0].index);
        } else {
          this.selectNav(this.item, 0);
        }
      }
    });

    this.sideNav1 = [
      {
        index: '0',
        name: 'Overview',
        image: '/assets/images/Overview-inactive.png',
        selectedImage: '/assets/images/overview-active.png',
        link: '/overview',
        sub: [],
      },
      {
        index: '1',
        name: 'Employees',
        image: '/assets/images/Employees-inactive.png',
        selectedImage: '/assets/images/employees-active.png',
        link: '/employees/employees-list',
        sub: [],
      },
      {
        index: '2',
        name: 'Meeting',
        link: '/meeting/meetingroom-list',
        image: '/assets/images/meeting-inactive.png',
        selectedImage: '/assets/images/Meeting-active.png',
        sub: [],
      },

      {
        index: '3',
        name: 'VMS',
        image: '../../../../../assets/images/vms.png',
        selectedImage: '../../../../../assets/images/vms_active.png',
        link: '',
        sub: [
          {
            index: '0',
            name: 'Individual Invite',
            image: '',
            selectedImage: '',
            link: '/vms/individual-invite',
          },
          {
            index: '1',
            name: 'Bulk Invite',
            image: '',
            selectedImage: '',
            link: '/vms/bulk-invite',
          },

        ],
      },
      {
        index: '4',
        name: 'Credits',
        link: '/credits',
        image: '/assets/images/Credits-inactive.png',
        selectedImage: '/assets/images/credits-active.png',
        sub: [],
      },
      {
        index: '5',
        name: 'Events',
        image: '../../../assets/images/Events-1.png',
        selectedImage: '../../../assets/images/events_active.png',
        link: '/events',
        sub: [],
      },
      {
        index: '6',
        name: 'Reports',
        link: '/reports',
        image: '/assets/images/Reports-inactive.png',
        selectedImage: '/assets/images/reports-active.png',
        sub: [],
      },
      {
        index: '7',
        name: 'Contact',
        link: '/contact',
        image: '/assets/images/contact/contact-unselected-icon.png',
        selectedImage: '/assets/images/contact/contact-selected-icon.png',
        sub: [],
      },
      // {
      //   index: "6",
      //   name: "Company",
      //   link: '/company',
      //   image: '/assets/images/contact/contact-unselected-icon.png',
      //   selectedImage: '/assets/images/contact/contact-selected-icon.png'
      // }
    ];

    this.sideNav2 = [
      {
        index: '0',
        name: 'Overview',
        image: '/assets/images/Overview-inactive.png',
        selectedImage: '/assets/images/overview-active.png',
        link: '/overview',
        sub: [],
      },
      {
        index: '1',
        name: 'Reports',
        link: '/reports',
        image: '/assets/images/Reports-inactive.png',
        selectedImage: '/assets/images/reports-active.png',
        sub: [],
      },

      {
        index: '2',
        name: 'Company',
        link: '/company',
        image: '/assets/images/company/company.svg',
        selectedImage: '/assets/images/company/company-selected.png',
        sub: [],
      },
      {
        index: '3',
        name: 'VMS',
        image: '../../../../../assets/images/vms.png',
        selectedImage: '../../../../../assets/images/vms_active.png',
        link: '',
        sub: [
          {
            index: '0',
            name: 'Individual Invite',
            image: '',
            selectedImage: '',
            link: '/vms/individual-invite',
          },
          {
            index: '1',
            name: 'Bulk Invite',
            image: '',
            selectedImage: '',
            link: '/vms/bulk-invite',
          },
          {
            index: '2',
            name: 'Access',
            image: '',
            selectedImage: '',
            link: '/vms/invitation-rights',
          },
          {
            index: '3',
            name: 'Kiosk Invite',
            image: '',
            selectedImage: '',
            link: '/vms/kiosk-invite',
          },
        ],
      },
      {
        index: '4',
        name: 'Events',
        image: '../../../assets/images/Events-1.png',
        selectedImage: '../../../assets/images/events_active.png',
        link: '/events',
        sub: [],
      },
      // {
      //   index: '5',
      //   name: 'PMS Invite',
      //   image: '../../../../../assets/images/vms.png',
      //   selectedImage: '../../../../../assets/images/vms_active.png',
      //   link: '/pms/pms-invite',
      //   sub: [],
      // },
    ];


    this.allSideNav =
      localStorage.getItem('userType') == 'Parkite'
        ? this.sideNav2
        : this.sideNav1;


    // if (this.item) {
    //   this.selectNav(this.item, 0);
    // }
  }
  // selectNav(item, j) {

  //   if (this.item && this.item.length > 0) {
  //     this.selectedIndex = this.item[0].index;
  //     this.selectedMenu = this.item[0];
  //     this.router.navigate([this.item[0].link]);
  //     this.item = [];
  //   } else {
  //     this.selectedIndex = item.index;
  //     this.selectedMenu = item;
  //     this.subIndex = j;
  //     this.router.navigate([item?.link == '' ? item.sub[j].link : item.link]);
  //   }
  // }

  selectNav(item, j) {
    console.log('j', j);
    console.log('resssssssss', item);

    if (item && item.length > 0 && !item[0]?.hasOwnProperty('sub')) {
      this.expandVMS = false;
      this.expandPMS = false;
      this.selectedIndex = item[0].index;
      this.selectedMenu = item[0];
      this.subIndex = j;
      if (item[0].link !== '') this.router.navigate([item[0].link]);
      this.item = [];
    } else if (item[0]?.sub?.length > 0 && item[0]?.sub?.length < 1) {
      this.selectedIndex = item[0]?.index;
      this.selectedMenu = item[0];
      this.subIndex = j;
      this.router.navigate([
        item[0]?.link == '' ? item[0]?.sub[j].link : item[0]?.link,
      ]);
    } else if (item[0]?.sub?.length > 2) {
      this.selectedIndex = item[0]?.index;
      this.selectedMenu = item[0];
      this.subIndex = j;
      this.router.navigate([
        item[0]?.link == '' ? item[0]?.sub[j]?.link : item[0]?.link,
      ]);
    } else {
      console.log(item.length);
      this.selectedIndex = item?.index;
      this.selectedMenu = item;
      this.subIndex = j;
      if (item.length == undefined) {
        this.router.navigate([
          item.link == '' ? item?.sub[j]?.link : item?.link,
        ]);
      } else {
        this.router.navigate([
          item[0].link == '' ? item[0]?.sub[j]?.link : item[0]?.link,
        ]);
      }
    }
  }

  getAdminData() {
    this.adminSrv.getadmindetails().subscribe((details) => {
      this.adminData.name = details.data.adminName;
      this.adminData.emailId = details.data.adminEmailId;
      this.adminData.mobileNumber = details.data.phoneNumber;
      this.adminData.alternateEmailId = details.data.alternateEmailId;
      this.adminData.id = details.data.id;
      localStorage.setItem(
        AppConstant.localStorage.tenantId,
        details.data.tenantId
      );
      localStorage.setItem(AppConstant.localStorage.userId, details.data.id);
      this.notificationSrv.getAllNotifications().subscribe();
      //this.adminData.image = details.data.profileUrl;
      //this.initials = (this.adminData.name.split(' ')[0].charAt(0).toUpperCase()) + ' ' + ((this.adminData.name.split(' ')[1] === undefined || this.adminData.name.split(' ')[1] === null) ? '' : this.adminData.name.split(' ')[1].charAt(0).toUpperCase());
      var arrName = this.adminData.name.split(' ');
      if (arrName.length > 1) {
        this.initials =
          arrName[0].charAt(0).toUpperCase() +
          '' +
          arrName[1].charAt(0).toUpperCase();
      } else {
        this.initials = arrName[0].charAt(0).toUpperCase();
      }
      //this.adminSrv.getAdminData().subscribe(details => {
      if (details.data.isAdmin == true) {
        localStorage.setItem(AppConstant.localStorage.isAdmin, '1');
      } else {
        localStorage.setItem(AppConstant.localStorage.isAdmin, '0');
      }
      //})
      this.adminSrv.setAdminDetails(details);
    });
  }

  getParkiteAdmin() {
    this.adminSrv.getParkiteAdmin().subscribe((details) => {
      console.log(details.data);
      localStorage.setItem('parkId', details.data.parkID);
      localStorage.setItem('cityId', details.data.cityId);
      localStorage.setItem('parkTenantId', details.data.parkTenantId);
      localStorage.setItem('isRoleAdmin', details.data.isAdmin);
      // this.adminData.name = details.data.parkName;
      // this.adminData.emailId = details.data.adminEmailId;
      // this.adminData.mobileNumber = details.data.phoneNumber;
      // this.adminData.alternateEmailId = details.data.alternateEmailId;
      // this.adminData.id = details.data.id;
      // localStorage.setItem(AppConstant.localStorage.tenantId, details.data.tenantId);
      // localStorage.setItem(AppConstant.localStorage.userId, details.data.id);
      var arrName = details.data.adminName.split(' ');
      if (arrName.length > 1) {
        this.initials =
          arrName[0].charAt(0).toUpperCase() +
          '' +
          arrName[1].charAt(0).toUpperCase();
      } else {
        this.initials = arrName[0].charAt(0).toUpperCase();
      }
      //this.adminSrv.getAdminData().subscribe(details => {
      if (details.data.isAdmin == true) {
        localStorage.setItem(AppConstant.localStorage.isAdmin, '1');
      } else {
        localStorage.setItem(AppConstant.localStorage.isAdmin, '0');
      }
    });
  }

  checkActive(link) {
    if (!this.locationUrl) {
      this.locationUrl = this.location.path();
    }
    console.log(
      'this.locationUrl.indexOf(link)',
      this.locationUrl.indexOf(link)
    );
    if (this.locationUrl && this.locationUrl.indexOf(link) !== -1) {
      return true;
    }
    return false;
  }

  toggle(type) {
    this.expandVMS = type == 'close' ? false : !this.expandVMS;
    this.expandPMS = type == 'close' ? false : !this.expandPMS;
  }
}
